/**
 * @module root\plugin\components\datePicker
 */
import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import moment from "moment";

@Component
export default class DatePicker extends Vue {
  @Prop({
    default: [],
    type: Array,
    required: true
  })
  errorMessages!: Array<string>;
  @Prop({
    type: Boolean,
    default: false,
    required: false
  })
  required!: boolean;
  @Prop({
    type: Boolean,
    default: false
  })
  readonly!: boolean;
  @Prop({
    type: String,
    required: true
  })
  label!: string;
  @Prop({
    type: String
  })
  maxDate!: string;
  @Prop({
    type: String
  })
  minDate!: string;
  @Prop({
    type: String
  })
  hint!: string;
  date = "";
  menu = "";
  dateField = "";
  frmDate = "";
  isValid = false;
  changeFormat() {
    if (this.date) this.dateField = moment(this.date).format("DD-MMM-YYYY");
    this.$emit("input",  moment(this.date).format("DD-MMM-YYYY"));
  }
  checkDateFormat() {
    if (!this.dateField) {
      this.$emit("input", undefined);
      return;
    }
    this.isValid = moment(this.dateField, "D-M-YYYY", true).isValid();
    if (this.isValid) {
      this.date = moment(this.dateField, "D-M-YYYY", true).format("YYYY-MM-DD");
      this.$emit("input", moment(this.dateField, "D-M-YYYY", true).toDate());
    } else {
      this.$emit("input", false);
    }
  }

  get stringMaxDate() {
    if (!this.maxDate) return "";
    return moment(this.maxDate).format("YYYY-MM-DD");
  }

  get stringMinDate() {
    if (!this.minDate) return "";
    return moment(this.minDate).format("YYYY-MM-DD");
  }

  clear(){
    this.dateField="";
  }
}
